<template>
  <div>
    <multi-select v-model="valueInternal"
                  v-on:input="$emit('input', valueInternal)"
                  :options="options"
                  :multiple="true"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :hide-selected="true"
                  :taggable="true"
                  track-by="title"
                  label="title"
                  :placeholder="placeholder"
                  tag-placeholder="Enter чтобы создать"
                  selectLabel="Enter чтобы выбрать"
                  @tag="addTag"
                  @search-change="asyncFind"
    >
      <template slot="noOptions">Начните вводить название</template>
    </multi-select>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'

export default {
  name: "tags",
  components: {MultiSelect},
  props: {
    value: Array,
    placeholder: {
      Type: String,
      Default: 'Введите название для поиска или создания'
    }
  },
  data() {
    return {
      valueInternal: {},
      options: [],
      isLoading: false
    }
  },
  watch: {
    'value': {
      handler: function (data) {
        if (data) {
          this.valueInternal = data;
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.valueInternal = this.value;
  },
  methods: {
    asyncFind(query) {
      this.isLoading = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tags?query=' + query);
      return promise.then(response => {
        this.options = response.data.tags;
        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
        this.options = [];
        this.isLoading = false;
      });
    },
    addTag(newTag) {
      this.isLoading = true
      this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/tags/', {title: newTag}).then(response => {
        const tag = {
          title: newTag,
          id: response.data.tag.id
        }
        this.options.push(tag);
        this.valueInternal.push(tag);
        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
        this.isLoading = false;
      });

    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__content-wrapper {
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5);
}
</style>
